import { render, staticRenderFns } from "./CompensationsSelectPeople.vue?vue&type=template&id=60049301"
import script from "./CompensationsSelectPeople.vue?vue&type=script&lang=js"
export * from "./CompensationsSelectPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports